import { getPatientHome } from '../endpoints';
import { WsError } from '@/lib/wiservice';
import type { PatientHomeView } from '../types';

// apiv2 WS_STATUS_OBJECT_NOTFOUND — mirror get_patient_file: a missing patient may
// come back 380 (or 200-with-nulls), so this is defensive.
const WS_STATUS_OBJECT_NOTFOUND = 380;

// NOT_FOUND → null (renders the empty "no patient home" state). Other errors propagate.
// Returns the raw snake_case view (NUMERIC still strings — logic/patientHome coerces).
export async function fetchPatientHome(
  withingsUserId: string | number,
  programid?: string,
): Promise<PatientHomeView | null> {
  let data: PatientHomeView | undefined;
  try {
    // apiv2 defaults open_tasks to pending,in_progress — but the sections render
    // overdue (hero), completed (library progress + recent-completion), and
    // available-now scheduled tasks, so request the full patient-facing set.
    const params: Record<string, unknown> = {
      clinical_id_dev_user: String(withingsUserId),
      clinical_tasks_status: 'pending,in_progress,overdue,scheduled,completed',
    };
    if (programid) params.programid = programid;
    const body = await getPatientHome(params);
    data = body?.data;
  } catch (e) {
    if ((e as WsError)?.status === WS_STATUS_OBJECT_NOTFOUND) return null;
    throw e;
  }
  return data ?? null;
}
